export default [
    {
        id: 1,
        descripcion: 'ALTA'
    },
    {
        id: 2,
        descripcion: 'MEDIA'
    },
    {
        id: 3,
        descripcion: 'BAJA'
    }
]